/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 5/7/15.
 */

function ModalServiceConstructor(
    this: JS5Object,
    _: JS5Object,
    $uibModal: JS5Object,
    ContentResourceFactory: JS5Object,
    LanguageResourceFactory: JS5Object,
    PackageResourceFactory: JS5Object,
    PartnerResourceFactory: JS5Object,
    RoleResourceFactory: JS5Object,
    TerritoriesService: JS5Object,
) {
    let openModals: Array<JS5Object> = [];

    const removemodal = (modal: JS5Object) => {
        let modalIndex = openModals.indexOf(modal);
        openModals.splice(modalIndex, 1);
    };

    const handleNewModal = (modal: JS5Object, resultHandler: JS5Function = null, cancelHandler: JS5Function = null) => {
        openModals.push(modal);

        modal.result.then((result) => {
            if (resultHandler) {
                resultHandler(result);
            }
            removemodal(modal);
        }, (cancelMessage) => {
            if (cancelHandler) {
                cancelHandler(cancelMessage);
            }
            removemodal(modal);
        });
    };

    this.currentModalInstance = () => {
        return openModals.length ? openModals[openModals.length - 1] : null;
    };

    this.closeAllModals = () => {
        angular.forEach(openModals, (modal) => {
            modal.dismiss('cancel');
            modal = null;
        });
        openModals = [];
    };

    this.closeCurrentModal = () => {
        if (this.currentModalInstance()) {
            this.currentModalInstance().dismiss('cancel');
        }
    };

    this.showMessageModal = (options, resultHandler, cancelHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'components/modal/message-modal-template.html',
            controller: 'MessageModalController as msgMdlCntrlr',
            windowClass: options.windowClass,
            resolve: {
                options: () => {
                    return options;
                }
            }
        });

        handleNewModal(modal, resultHandler, cancelHandler);
    };

    this.showFileSelectionModal = (fileFilterType, resultHandler, validateFileFunc) => {
        let modal = $uibModal.open({
            component: 'selectAssetModal',
            windowClass: 'file-browser-modal',
            resolve: {
                fileFilterType: () => {
                    return fileFilterType;
                },
                validateFileFunc: () => {
                    return validateFileFunc;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showFileUploadModal = (acceptTemplateMembers, fileFilterType, resultHandler) => {
        let modal = $uibModal.open({
            component: 'fileUploadModal',
            resolve: {
                acceptTemplateMembers: () => {
                    return acceptTemplateMembers;
                },
                fileFilterType: () => {
                    return fileFilterType;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showAddCollaboratorModal = (availableCollaborators, type, resultHandler, savedRoles, showContentCollaborators, isSeries, allowMultiSelect: boolean = true, showNewButton: boolean = true) => {
        const modal = $uibModal.open({
            component: 'collaboratorAddModal',
            windowClass: 'add-collaborator-modal',
            resolve: {
                collaborators: () => availableCollaborators,
                type: () => type,
                savedRoles: () => savedRoles,
                showContentCollaborators: () => showContentCollaborators,
                isSeries: () => isSeries,
                allowMultiSelect: () => allowMultiSelect,
                showNewButton: () => showNewButton
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showNewCrewCollaboratorModal = (newActor: boolean, resultHandler: JS5Function) => {
        let modal = $uibModal.open({
            component: 'addNewCrewCollaboratorModal',
            resolve: {
                newActor: () => newActor
            }
        });

        handleNewModal(modal, resultHandler);
    };
    this.showCreateCollaboratorModal = (resultHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'meta/collaborator/editor/components/create-collaborator-modal-template.html',
            controller: 'CreateCollaboratorModalController as createCollaborator'
        });

        handleNewModal(modal, resultHandler);
    };
    this.showGroupsModal = (availableGroups: JS5Object[], resultHandler: JS5Function) => {
        let modal = $uibModal.open({
            component: 'groupsModal',
            resolve: {
                availableGroups: () => {
                    return availableGroups;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };
    this.showAliasesModal = (resultHandler: JS5Function) => {
        let modal = $uibModal.open({
            component: 'aliasesModal',
        });

        handleNewModal(modal, resultHandler);
    };
    this.showMediaAcceptProfilesModal = (resultHandler: JS5Function, mediaAcceptProfileType: string) => {
        let modal = $uibModal.open({
            component: 'mediaAcceptProfilesModal',
            resolve: {
                mediaAcceptProfileType: () => mediaAcceptProfileType
            }
        });

        handleNewModal(modal, resultHandler);
    };
    this.showEditableQualityControlModal = (asset, canEdit, resultHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'package/editor/components/modals/qualitycontrol/quality-control-modal-template.html',
            controller: 'QualityControlModalController as qualCntrlMdlCntrlr',
            windowClass: 'package-qc-modal',
            resolve: {
                qcNoteData: () => {
                    return asset.qualityControlNote;
                },
                canEdit: () => {
                    return canEdit;
                }
            }
        });

        openModals.push(modal);

        modal.result.then((qcNote) => {
            resultHandler(asset, qcNote);
            removemodal(modal);
        }, () => {
            removemodal(modal);
        });
    };

    this.showPackageQCNotesModal = (mediaData) => {
        let modal = $uibModal.open({
            templateUrl: 'package/manager/modals/packagequalitycontrol/package-quality-control-modal-template.html',
            controller: 'QualityControlModalController as qualCntrlMdlCntrlr',
            windowClass: 'package-qc-modal',
            resolve: {
                qcNoteData: () => {
                    return mediaData;
                },
                canEdit: () => {
                    return false;
                }
            }
        });

        handleNewModal(modal);
    };

    this.showViewAssetModal = (packageContent, secondaryAsset, downloadFileNamePrefix, contentTemplateUrl,
                               showPreview) => {
        let modal = $uibModal.open({
            component: 'viewAssetModal',
            windowClass: 'view-asset-modal',
            resolve: {
                packageContent: () => packageContent,
                secondaryAsset: () => secondaryAsset,
                downloadFileNamePrefix: () => downloadFileNamePrefix,
                contentTemplateUrl: () => contentTemplateUrl,
                showPreview: () => showPreview
            }
        });

        handleNewModal(modal);
    };

    this.showErrorsWarningsModal = (validationResults, packageName, showCancel, resultHandler) => {
        let modal = $uibModal.open({
            component: 'errorsWarningsModal',
            windowClass: 'errors-warnings-modal',
            resolve: {
                validationResults: () => validationResults,
                packageName: () => packageName,
                showCancel: () => showCancel
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showNewPackageModal = (resultHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'package/manager/modals/newPackage/new-package-modal-template.html',
            controller: 'NewPackageModalController as newPackageCtrl',
            windowClass: 'new-package-modal'
        });

        handleNewModal(modal, resultHandler);
    };

    this.showContentSubscriptionPropertiesModal = (subscriptions, batchUpdate, isPartner, resultHandler, cancelHandler) => {
        let modal = $uibModal.open({
            component: 'subscriptionPropertiesModal',
            windowClass: 'metadata-properties-modal',
            resolve: {
                isPartner: () => {
                    return isPartner;
                },
                subscriptions: () => {
                    return subscriptions;
                }
            }
        });

        handleNewModal(modal, resultHandler, cancelHandler);
    };

    this.showPartnerEmailRecipientModal = (recipientObject, resolveHandler) => {
        handleNewModal(
            $uibModal.open({
                component: 'partnerEmailRecipientModal',
                resolve: {
                    recipientObject: () => {
                        return recipientObject;
                    },
                },
            }),
            resolveHandler);
    };

    this.showContactsSelectModal = (existingContactIds, resultHandler) => {
        handleNewModal(
            $uibModal.open({
                component: 'contactsSelectModal',
                resolve: {
                    existingContactIds: () => {
                        return existingContactIds;
                    },
                },
            }),
            resultHandler);
    };

    this.showContentSelectModal = (contentType, contents, resultHandler) => {
        let modal = $uibModal.open({
            component: 'contentSelectModalComponent',
            windowClass: 'content-browser-modal',
            resolve: {
                contentType: () => contentType,
                contents: () => contents
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showRejectPackageModal = (rejectReason, showRejectClipWarning, editable, resultHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'package/editor/components/modals/rejectPackage/reject-package-modal-template.html',
            controller: 'RejectPackageModalController as rejectPkgCntrlr',
            resolve: {
                rejectReason: () => {
                    return rejectReason;
                },
                showRejectClipWarning: () => {
                    return showRejectClipWarning;
                },
                editable: () => {
                    return editable;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showCompletedDeliveriesModal = (packageObject, resultHandler) => {
        handleNewModal(
            $uibModal.open({
                component: 'completedDeliveriesModal',
                windowClass: 'completed-deliveries-modal',
                resolve: {
                    packageObject: () => packageObject
                }
            }),
            resultHandler,
            resultHandler);
    };

    this.showCheckinResultModal = (resultsDict, resultHandler) => {
        handleNewModal(
            $uibModal.open({
                component: 'checkinResultModal',
                windowClass: 'checkin-result-modal',
                resolve: {
                    resultsDict: () => resultsDict
                },
            }),
            resultHandler,
            resultHandler);
    };

    this.showAdHocSelectPartnersModal = (currentPartners, isSeries, isSeason, isVolume, resultHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'package/editor/components/modals/adHocSelectPartners/adhoc-subscription-modal-template.html',
            controller: 'AdHocSelectPartnersModalController as adHocPartnersCntrlr',
            resolve: {
                currentPartners: () => {
                    return currentPartners;
                },
                isSeries: () => {
                    return isSeries;
                },
                isSeason: () => {
                    return isSeason;
                },
                isVolume: () => {
                    return isVolume;
                },
                allPartners: () => {
                    return PartnerResourceFactory.query({fetchLimit: 1000}).$promise;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showLiveClipScheduleModal = (packageObject, defaultFeed, liveFeeds, cancelHandler, resultHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'package/editor/components/view/liveclip/modals/clipSchedule/clip-schedule-modal-template.html',
            controller: 'ClipScheduleModalController as scheduleCtrlr',
            windowClass: 'clip-schedule-modal',
            resolve: {
                packageObject: () => {
                    return packageObject;
                },
                defaultFeed: () => {
                    return defaultFeed;
                },
                liveFeeds: () => {
                    return liveFeeds;
                },
                cancelRecordHandler: () => {
                    return cancelHandler;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showCreateClipModal = (resultHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'package/editor/components/view/liveclip/modals/createNewClip/create-clip-modal-template.html',
            controller: 'CreateClipModalController as createClipMdlCntrlr'
        });

        openModals.push(modal);
        modal.result.then((result) => {
            resultHandler(result);
            removemodal(modal);
        }, () => {
            removemodal(modal);
        });
    };

    this.showSelectDraftClipModal = (draftClips, resultHandler, cancelHandler) => {
        let modal = $uibModal.open({
            component: 'selectDraftClipModal',
            resolve: {
                draftClips: () => draftClips
            }
        });

        handleNewModal(modal, resultHandler, cancelHandler);
    };

    this.showAddLiveFeedModal = (liveFeeds, liveFeed, resultHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'meta/content/editor/components/modals/addShowLiveFeed/add-showlivefeed-modal-template.html',
            controller: 'AddShowLiveFeedModalController as addShowLiveFeedCtrlr',
            resolve: {
                availableFeeds: () => {
                    return liveFeeds;
                },
                showLiveFeed: () => {
                    return liveFeed;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showAddContentCategoryModal = (contentId, resultHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'meta/content/editor/components/modals/addContentCategoriesModal/add-content-categories-modal-template.html',
            controller: 'AddContentCategoriesModalController as addContentCategoriesModalCtrl',
            resolve: {
                availableCategories: () => {
                    return PackageResourceFactory.getCategories({view: 'EXTENDED'}).$promise;
                },
                existingContentCategories: () => {
                    return ContentResourceFactory.getContentCategories({id: contentId}).$promise;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showNewSubscriptionModal = (packageCategoryTypeId, packageCategoryId, contentId, networkId, resultHandler) => {
        let modal = $uibModal.open({
            component: 'newSubscriptionModal',
            windowClass: 'new-subscription-modal',
            resolve: {
                packageCategoryTypeId: () => {
                    return packageCategoryTypeId;
                },
                packageCategoryId: () => {
                    return packageCategoryId;
                },
                contentId: () => {
                    return contentId;
                },
                networkId: () => {
                    return networkId;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showSelectDeliveryPartnersModal = (resultHandler: JS5Function) => {
        let modal = $uibModal.open({
            templateUrl: 'package/common/selectDeliveryPartnersModal/select-delivery-partners-modal-template.html',
            controller: 'SelectDeliveryPartnersModalController as selectDeliveryPartnersMdlCtrlr',
            windowClass: 'select-delivery-partners-modal',
            resolve: {}
        });

        handleNewModal(modal, resultHandler);
    };

    this.showCreateReportModal = (report, resultHandler, showPartners) => {
        let modal = $uibModal.open({
            templateUrl: 'dashboard/reports/modals/createReportModal/create-report-modal-template.html',
            controller: 'CreateReportModalController as createReportModal',
            resolve: {
                report: () => report,
                showPartners: () => showPartners
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showSelectMasterMediaTypesModal = (resultHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'package/common/selectMasterMediaTypesModal/select-master-media-types-modal-template.html',
            controller: 'SelectMasterMediaTypesModalController as selectMasterMediaTypesModal',
            windowClass: 'select-media-content-modal'
        });

        handleNewModal(modal, resultHandler);
    };

    this.showAssetValidationResultsModal = (validationResults, showCancel, resultHandler) => {
        let modal = $uibModal.open({
            component: 'errorsWarningsModal',
            templateUrl: 'package/editor/components/modals/assetValidationResults/asset-validation-results-modal-template.html',
            windowClass: 'errors-warnings-modal',
            resolve: {
                validationResults: () => {
                    return validationResults;
                },
                packageName: () => {
                    return '';
                },
                showCancel: () => {
                    return showCancel;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showAssetModal = (asset, contentTemplate, assetType, resultHandler) => {
        let modal = $uibModal.open({
            component: 'assetInfoModal',
            resolve: {
                contentTemplate: () => contentTemplate,
                asset: () => asset,
                assetType: () => assetType
            }
        });

        handleNewModal(modal);
    };

    this.showPMSearchFilterModal = (resultHandler, cancelHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'package/manager/modals/filter/filter-modal-template.html',
            controller: 'FilterModalController as pmFilterModal',
            windowClass: 'search-filter-modal'
        });
        handleNewModal(modal, resultHandler, cancelHandler);
    };

    this.showPkgTimingEditModal = (pkgTiming, resultHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'package/editor/components/view/timings/editor/pkg-timing-edit-modal-template.html',
            controller: 'PackageTimingEditModalController as pkgTimingEditor',
            resolve: {
                pkgTiming: () => {
                    return pkgTiming;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showPkgHierarchicalMetadataModal = (packageObject) => {
        handleNewModal(
            $uibModal.open({
                component: 'hierarchicalMetadataModal',
                windowClass: 'hierarchical-metadata-modal',
                resolve: {
                    packageObject: () => packageObject,
                },
            }));
    };

    this.showBrandingDistributionOverridesModal = (partnerPackage, packageObject, viewState, readOnly,
                                                   resultHandler) => {
        handleNewModal(
            $uibModal.open({
                component: 'brandingDistributionOverridesModal',
                windowClass: 'wide-message-modal',
                resolve: {
                    partnerPackage: () => partnerPackage,
                    packageObject: () => packageObject,
                    viewState: () => viewState,
                    readOnly: () => readOnly,
                },
            }),
            resultHandler);
    };

    this.showMediaModal = (type, media, clipId, resultHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'components/modal/media-modal/media-modal-template.html',
            controller: 'MediaModalController as mediaModal',
            windowClass: 'wide-message-modal',
            resolve: {
                type: () => type,
                media: () => media,
                clipId: () => clipId
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showMetadataItemEditorModal = (ownerClass, propertyId, mvpd, conversion, resultHandler) => {
        let modal = $uibModal.open({
            component: 'metadataItemEditModal',
            windowClass: 'metadata-property-modal',
            resolve: {
                ownerClass: () => {
                    return ownerClass;
                },
                propertyId: () => {
                    return propertyId;
                },
                mvpd: () => mvpd,
                conversion: () => conversion,
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showWorkflowSearchFilterModal = (resultHandler, cancelHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'dashboard/workflows/searchView/modals/filter/workflow-filter-modal-template.html',
            controller: 'FilterModalController as workflowFilterModal',
            windowClass: 'search-filter-modal'
        });

        handleNewModal(modal, resultHandler, cancelHandler);
    };

    this.showQueueLimiterModal = (queueId, resultHandler, closeHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'dashboard/queues/modals/queueLimiterList/queue-limiter-list-modal-template.html',
            controller: 'QueueLimiterListController as queueLimiterController',
            windowClass: 'queue-limiter-list-modal',
            resolve: {
                queueId: () => {
                    return queueId;
                }
            }
        });

        handleNewModal(modal, resultHandler, closeHandler);
    };

    this.showQueueLimiterEditModal = (limiterId, queueMaxActive, resultHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'dashboard/queues/modals/queueLimiterEditor/queue-limiter-edit-template.html',
            controller: 'QueueLimiterEditController as queueLimiterEditCtrl',
            windowClass: 'queue-limiter-edit-modal',
            resolve: {
                limiterId: () => {
                    return limiterId;
                },
                queueMaxActive: () => {
                    return queueMaxActive;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showNewDeliveryEndpointModal = (supportedEndpointTypes, resultHandler) => {
        let modal = $uibModal.open({
            component: 'newDeliveryEndpointModal',
            resolve: {
                supportedEndpointTypes: () => {
                    return supportedEndpointTypes;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showContentCategorySubscriptionFilterModal = (seasons: JS5Object[], volumes: JS5Object[],
                                                       resultHandler: JS5Function, cancelHandler: JS5Function) => {
        let modal = $uibModal.open({
            component: 'contentSubscriptionFilterModal',
            resolve: {
                availableSeasons: () => seasons,
                availableVolumes: () => volumes
            }
        });

        handleNewModal(modal, resultHandler, cancelHandler);
    };

    this.showPartnerSubscriptionFilterModal = (resultHandler, cancelHandler) => {
        let modal = $uibModal.open({
            templateUrl: 'system/partner/editor/components/view/subscriptions/modal/partner-subscription-filter-template.html',
            controller: 'FilterModalController as pmFilterModal',
            windowClass: 'partner-sub-filter-modal'
        });

        handleNewModal(modal, resultHandler, cancelHandler);
    };

    this.showNewMediaProfileModal = (resultHandler, acceptProfiles) => {
        let modal = $uibModal.open({
            component: 'newMediaProfileModal',
            resolve: {
                acceptProfiles: () => {
                    return acceptProfiles;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };
    this.showChangePasswordModal = (okayHandler, cancelHandler) => {
        let modal = $uibModal.open({
            component: 'changePasswordModal'
        });

        handleNewModal(modal, okayHandler, cancelHandler);
    };

    this.showPartnerPackageAcceptRejectModal = (action, partnerPackagePartnerName, okayHandler, cancelHandler) => {
        let modal = $uibModal.open({
            component: 'partnerPackageAcceptRejectModal',
            resolve: {
                action: () => action,
                partnerPackagePartnerName: () => partnerPackagePartnerName
            }
        });

        handleNewModal(modal, okayHandler, cancelHandler);
    };

    this.showGroupsExceptionModal = (series: Array<JS5Object>, movies: Array<JS5Object>,
                                     categories: Array<JS5Object>, exceptionPermission: JS5Object,
                                     isEdit: boolean, resultHandler: JS5Function) => {
        let modal = $uibModal.open({
            component: 'groupsExceptionModal',
            resolve: {
                series: () => series,
                movies: () => movies,
                categories: () => categories,
                exceptionPermission: () => exceptionPermission,
                isEdit: () => isEdit
            }
        });

        handleNewModal(modal, resultHandler);
    };

    this.showExternalIngestTypeModal = (okayHandler, cancelHandler) => {
        let modal = $uibModal.open({
            component: 'externalIngestTypeModal'
        });

        handleNewModal(modal, okayHandler, cancelHandler);
    };

    this.showExternalIngestRunModal = (externalIngestSourceId, okayHandler, cancelHandler) => {
        let modal = $uibModal.open({
            component: 'externalIngestRunModal',
            resolve: {
                externalIngestSourceId: () => externalIngestSourceId,
            }
        });

        handleNewModal(modal, okayHandler, cancelHandler);
    };

    this.showExternalIngestQueueEditorModal = (
        externalIngestJobs: JS5Object[],
        saveHandler: JS5Function,
        cancelHandler: JS5Function,
    ) => {
        let modal = $uibModal.open({
            component: 'externalIngestQueueEditorModal',
            resolve: {
                externalIngestJobs: () => externalIngestJobs
            }
        });

        handleNewModal(modal, saveHandler, cancelHandler);
    };

    this.showJsonViewerModal = (jsonData: JS5Object) => {
        let modal = $uibModal.open({
            component: 'jsonViewerModal',
            resolve: {
                jsonData: () => jsonData
            },
            windowClass: 'json-viewer-modal'
        });

        handleNewModal(modal);
    };

    this.showMetricsFilterModal = (acceptHandler: JS5Function) => {
        let modal = $uibModal.open({
            component: 'metricsFilterModal',
            windowClass: 'metrics-filter-modal'
        });

        handleNewModal(modal, acceptHandler);
    };

    this.showMMCInventoryModal = (packageId: string, partnerId: string, readOnly: boolean) => {
        let modal = $uibModal.open({
            component: 'mmcInventoryModal',
            resolve: {
                packageId: () => packageId,
                partnerId: () => partnerId,
                readOnly: () => readOnly
            },
            windowClass: 'mmc-inventory-modal'
        });

        handleNewModal(modal);
    };

    this.showAttachmentSelectModal = (availableDeliveryItems: JS5Object[], resultHandler: JS5Function) => {
        let modal = $uibModal.open({
            component: 'attachmentSelectModal',
            resolve: {
                availableDeliveryItems: () => availableDeliveryItems
            },
            windowClass: 'attachment-select-modal'
        });

        handleNewModal(modal, resultHandler);
    };

    this.showQueuePriorityEditorModal = (queueSteps: JS5Object[], resultHandler: JS5Function) => {
        let modal = $uibModal.open({
            component: 'queuePriorityModal',
            resolve: {
                queueSteps: () => queueSteps
            },
        });

        handleNewModal(modal, resultHandler);
    }

    this.showFileProgressModal = (initUploads?: JS5Object[], canInsertRows?: boolean, resultHandler?: JS5Function) => {
        let modal = $uibModal.open({
            component: 'fileProgressModal',
            resolve: {},
            windowClass: 'file-progress-modal',
        });

        handleNewModal(modal, resultHandler);
    };

    this.showMoveDirectoryModal = (sourceFileSystemId, resultHandler) => {
        handleNewModal(
            $uibModal.open({
                component: 'moveDirectoryModal',
                resolve: {
                    sourceFileSystemId: () => {
                        return sourceFileSystemId;
                    },
                },
            }),
            resultHandler);
    };

    this.showGenerateAcceptProfileModal = (mediaAcceptProfileType, mediaAcceptProfileId, resultHandler) => {
        let modal = $uibModal.open({
            component: 'generateAcceptProfileModal',
            resolve: {
                mediaAcceptProfileType: () => {
                    return mediaAcceptProfileType;
                },
                mediaAcceptProfileId: () => {
                    return mediaAcceptProfileId;
                }
            }
        });

        handleNewModal(modal, resultHandler);
    };
}

angular.module('prism-ui.components').service('ModalService', ModalServiceConstructor);
